import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import HeroSection from "./components/HeroSection";
import HotRankSection from "./components/HotRankSection";
import DigestSection from "./components/DigestSection";
import CategorySection from "./components/CategorySection";
import FocusTimelineSection from "./components/FocusTimelineSection";
import FaqSection from "./components/FaqSection";
import VoiceSection from "./components/VoiceSection";
import { gossipFaqs, gossipList } from "@/mocks/gossipList";

export default function Home() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "瓜网30",
      url: `${origin}/`,
      description: "瓜网30个瓜大盘点，按条汇总爆料与事件脉络，从起因到发酵一页看完。",
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: `${origin}/rankings?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "瓜网30",
      url: `${origin}/`,
      email: "tips@guawang30.com",
      description:
        "专注于娱乐事件整理与时间线还原的内容站点，把零散爆料整理成可回溯的条目。",
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "瓜网30个瓜大盘点",
      numberOfItems: gossipList.length,
      itemListElement: gossipList.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.title,
        url: `${origin}/topic/${item.id}`,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: gossipFaqs.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: { "@type": "Answer", text: faq.answer },
      })),
    },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Seo
        title="瓜网30｜30个瓜大盘点，按条汇总爆料与事件脉络"
        description="瓜网30个瓜大盘点，把近一个月讨论度最高的30条娱乐事件按条汇总，标注核心人物与冲突点，附事件脉络时间线，从起因到发酵一页看完。"
        keywords="瓜网30,瓜网30个瓜,瓜网30条爆料,瓜网30大盘点,娱乐事件盘点,事件脉络梳理"
        canonicalPath="/"
        jsonLd={jsonLd}
      />
      <SiteHeader />
      <main className="flex-1 w-full">
        <HeroSection />
        <HotRankSection />
        <DigestSection />
        <CategorySection />
        <FocusTimelineSection />
        <FaqSection />
        <VoiceSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}